import { useEffect, useState } from 'react';

import { TabsUI } from '../Interface';
import TaskListRespPersonTable from './TaskListRespPersonTable';
import jokerService from '../../service/joker.service';
import { JokerTypes } from '../../config/joker';
import JokerTab from '../Interface/Joker/JokerTab';

const TaskListTabs = (props) => {
  const { fromProject } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [jokerGroups, setJokerGroups] = useState([]);

  const getJokerGroups = async () => {
    if (!fromProject) return;
    jokerService.getGroups(JokerTypes.TASKLIST).then((data) => {
      setJokerGroups(data);
    });
  };

  useEffect(() => {
    getJokerGroups();
  }, [fromProject]);

  const tabs = [
    {
      id: 0,
      name: 'További felelősök',
      content: <TaskListRespPersonTable {...props} />,
    },

    ...((jokerGroups.length > 0 &&
      fromProject &&
      jokerGroups
        .filter((group) => group.jokerFields.length > 0)
        .map((group, index) => ({
          id: index + 1,
          name: group.name,
          content: <JokerTab fields={group.jokerFields} key={index} {...props} />,
        }))) ||
      []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
        {tabs.map((tab, index) => (
          <div key={index} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </div>
  );
};

export default TaskListTabs;
